import axios from 'axios'
import ApiUrl from '../Constant/baseUrl'
import SecureLS from 'secure-ls'
export default class supportSeriveApliCall {
     constructor(){
         this.getBaseUrl= new ApiUrl()
     }
    AdminViewAllTicket() {
        var ls = new SecureLS();
        let uuid=ls.get('key1').uuid
        let jwttoken=ls.get('key1').jwtToken
        return axios({
            method: 'GET',
            url: `${this.getBaseUrl.ApiBAseURL}/api/admin/getAllTicket?adminUuid=${uuid}&pageSize=0&dataSize=10000`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Token ' + jwttoken,
                'X-Frame-Options': 'sameorigin'
            },
        })

    }
    AdminViewDetailsByTicketId(ticketID) {
        var ls = new SecureLS();
        let uuid=ls.get('key1').uuid
        let jwttoken=ls.get('key1').jwtToken
        return axios({
            method: 'GET',
            url: `${this.getBaseUrl.ApiBAseURL}/api/admin/ticket/${uuid}/${ticketID}`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Token ' + jwttoken,
                'X-Frame-Options': 'sameorigin'
            },
        })
    }
    AdminChangeSupportStatusByTicketId(ticketID, supportstatus) {
        var ls = new SecureLS();
        let uuid=ls.get('key1').uuid
        let jwttoken=ls.get('key1').jwtToken
        let tickcketid = ticketID
        let supportStatus = supportstatus
        let data = {
            adminUuid: uuid,
            ticketId: tickcketid,
            supportStatus: supportStatus
        }
        // console.log("send daat",data)
        return axios({
            method: 'PUT',
            url: `${this.getBaseUrl.ApiBAseURL}/api/admin/support/ticket/status`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Token ' + jwttoken,
                'X-Frame-Options': 'sameorigin'

            },
            data:data
        })
    }
    AdminCreateSupportCommentByTicketId(ticketID, supportComment) {
        var ls = new SecureLS();
        let uuid=ls.get('key1').uuid
        let jwttoken=ls.get('key1').jwtToken
        let tickcketid = ticketID
        let supportcomment = supportComment
        console.log("supportcommnet",supportComment)
        let data = {
            adminUuid: uuid,
            ticketId: tickcketid,
            supportComment: supportcomment,
        }
        return axios({
            method: 'PUT',
            url: `${this.getBaseUrl.ApiBAseURL}/api/admin/support/ticket/comment`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Token ' + jwttoken,
                'X-Frame-Options': 'sameorigin'

            },
            data:data
        })
    }
}